export default {
  type: "Feature",
  properties: {
    name: "Баянхонгор",
    location: [43.97515697026209, 100.36225503856261],
  },
  geometry: {
    type: "Polygon",
    coordinates: [
      [
        [97.56769180297852, 46.597444318795134],
        [97.63824462890625, 46.67205646734499],
        [97.69866943359375, 46.758679967095574],
        [97.7288818359375, 46.85079989251277],
        [97.734375, 46.9446372241817],
        [97.75360107421874, 46.9933677428342],
        [97.84423828125, 47.05889641405164],
        [97.8607177734375, 47.08882558740757],
        [97.86895751953125, 47.15236927446393],
        [97.9046630859375, 47.184112659842015],
        [97.96234130859375, 47.18971246448421],
        [98.052978515625, 47.172911278266604],
        [98.13812255859375, 47.200910301521674],
        [98.19580078125, 47.2270293988673],
        [98.2562255859375, 47.27922900257082],
        [98.2781982421875, 47.359292508710745],
        [98.272705078125, 47.42065432071321],
        [98.28369140625, 47.4596655525415],
        [98.37432861328125, 47.52461999690649],
        [98.40625762939453, 47.563090772707994],
        [98.4166431427002, 47.61490053602275],
        [98.4166431427002, 47.614958395343585],
        [98.48281860351562, 47.667237034505156],
        [98.55697631835936, 47.69682297134991],
        [98.79043579101562, 47.72362073407563],
        [98.800048828125, 47.646886969413],
        [98.83575439453125, 47.55521351530769],
        [98.93463134765625, 47.50421439972969],
        [98.97171020507812, 47.47266286861342],
        [99.05685424804688, 47.454094290400015],
        [99.21203613281249, 47.454094290400015],
        [99.26696777343749, 47.46152250874388],
        [99.33837890625, 47.489368981370724],
        [99.3768310546875, 47.517200697839414],
        [99.40567016601562, 47.5561403129434],
        [99.46884155273436, 47.5774521343697],
        [99.66110229492188, 47.60153331738691],
        [99.7174072265625, 47.62004976487241],
        [99.75860595703125, 47.619124098197325],
        [99.75723266601561, 47.53018378265907],
        [99.76821899414062, 47.4921528170241],
        [99.86572265625, 47.408573553097554],
        [99.89456176757812, 47.35650163792198],
        [99.90005493164062, 47.25593196573788],
        [99.91928100585938, 47.19251214527278],
        [99.920654296875, 47.121541375281744],
        [99.942626953125, 47.05889641405164],
        [100.0799560546875, 47.11219605898181],
        [100.23239135742188, 47.140227084105625],
        [100.447998046875, 47.184112659842015],
        [100.42053222656249, 47.089760603235646],
        [100.43426513671875, 47.041118014219414],
        [100.43838500976562, 47.00273390667881],
        [100.46859741210938, 46.97181933529799],
        [100.55992126464844, 46.95213711682888],
        [100.60729980468749, 46.931040990245364],
        [100.67459106445312, 46.86582490125156],
        [100.69381713867186, 46.83717984670198],
        [100.75561523437499, 46.830133640447386],
        [100.86685180664062, 46.83905867900795],
        [100.99113464355469, 46.82637528602131],
        [101.06666564941406, 46.82637528602131],
        [101.12091064453125, 46.83389173208538],
        [101.17652893066405, 46.850330293243495],
        [101.20536804199219, 46.836240405913],
        [101.22905731201172, 46.827197448507164],
        [101.26012802124023, 46.82367380645847],
        [101.28849506378174, 46.82616974343502],
        [101.28851652145386, 46.82616974343502],
        [101.436767578125, 46.638122462379656],
        [101.49856567382812, 46.580574564531695],
        [101.47933959960938, 46.54658317951774],
        [101.49993896484375, 46.50689964492765],
        [101.524658203125, 46.46056554578543],
        [101.4971923828125, 46.3810438458062],
        [101.49169921875, 46.195042108660154],
        [101.42578124999999, 46.115133713265415],
        [101.2994384765625, 46.06179698466216],
        [101.27197265625, 45.96642454131025],
        [101.29394531249999, 45.84410779560204],
        [101.3214111328125, 45.75985868785574],
        [101.2445068359375, 45.6178796835697],
        [101.2335205078125, 45.55252525134013],
        [101.151123046875, 45.47939202177826],
        [101.129150390625, 45.089035564831036],
        [101.1895751953125, 44.999767019181306],
        [101.3653564453125, 44.94536144236941],
        [101.5576171875, 44.867549659447214],
        [101.5850830078125, 44.809121700077355],
        [101.5521240234375, 44.766236875162335],
        [101.53564453124999, 44.64911632343077],
        [101.5960693359375, 44.574817404670306],
        [101.62353515625, 44.535674532413196],
        [101.68395996093749, 44.382765762252404],
        [101.7828369140625, 44.083146046165986],
        [101.80789947509764, 44.048917712794136],
        [101.8077278137207, 44.04897940326519],
        [101.74713134765625, 43.99676629896825],
        [101.4093017578125, 43.89789239125797],
        [101.2774658203125, 43.84839376489157],
        [101.15936279296875, 43.83650797709095],
        [100.58258056640625, 43.83254552160589],
        [100.40130615234375, 43.810747313446996],
        [100.23101806640625, 43.8503744993026],
        [100.01678466796875, 44.04219306625442],
        [99.91790771484375, 44.07377376789347],
        [99.7833251953125, 44.14476875978378],
        [99.64324951171875, 44.14082683077555],
        [99.55810546875, 44.125056482685146],
        [99.45373535156249, 44.10730980734024],
        [99.41528320312499, 44.050089820756796],
        [99.44549560546874, 43.8543357707896],
        [99.4482421875, 43.51668853502909],
        [99.49218749999999, 43.203173782105814],
        [99.580078125, 42.85985981506279],
        [99.5965576171875, 42.73289174571287],
        [99.59687948226929, 42.57930224162034],
        [99.5969009399414, 42.57937729240967],
        [99.50111389160155, 42.56623017635374],
        [98.52264404296875, 42.64204079304428],
        [98.184814453125, 42.656181890253855],
        [97.78913497924803, 42.709308508300325],
        [97.789306640625, 42.70968691975666],
        [97.789306640625, 42.98857645832184],
        [97.745361328125, 43.28520334369384],
        [97.84423828125, 43.40504748787035],
        [97.8662109375, 43.50075243569041],
        [97.91015624999999, 43.667871610117494],
        [97.9541015625, 43.94537239244209],
        [97.93212890625, 44.07969327425713],
        [97.91015624999999, 44.33956524809713],
        [97.987060546875, 44.41024041296011],
        [98.10791015625, 44.449467536006935],
        [98.184814453125, 44.6061127451739],
        [98.184814453125, 44.91813929958515],
        [98.360595703125, 45.166547157856016],
        [98.470458984375, 45.43700828867389],
        [98.404541015625, 45.78284835197676],
        [98.20678710937499, 45.98932892799953],
        [97.745361328125, 46.27863122156088],
        [97.657470703125, 46.532413816559455],
        [97.56752014160155, 46.59756227061819],
        [97.56769180297852, 46.597444318795134],
      ],
    ],
  },
};
